<div class="showcase"></div>
<div class="content">
    <div class="title">        
        Mi Equipo
    </div> 
    <div class="text slogan-team">
        <i>
            Porque si hoy mis pasos son más fuertes es por el peso que mi equipo tiene. Esta es la familia FD.
        </i>        
    </div>
    <div class="sub-title">
        Agentes y Managers FD
    </div>
    <div class="team-list">
        <div class="team-item" *ngFor="let person of teamAgents">
            <div>
                <img class="team-image" src="{{person.picture}}">                
                <div class="team-header">                  
                  <div class="team-title">{{person.name}}</div>
                  <div class="team-text">{{person.subname}}</div>
                </div>                
            </div>
        </div>
    </div>
    <div class="sub-title">
        Producción FD
    </div>
    <div class="team-list">
        <div class="team-item" *ngFor="let person of teamProductions">
            <div>
                <img class="team-image" src="{{person.picture}}">                
                <div class="team-header">                  
                  <div class="team-title">{{person.name}}</div>
                  <div class="team-text">{{person.subname}}</div>
                </div>                
            </div>
        </div>
    </div>
    <go-to-top></go-to-top>
</div>